import { NavLink } from "react-router-dom";

import Socials from "../socials/socials";
import "./navigation.css";

export default function Navigation({ open }: { open: boolean }) {
  const navOptions = [
    {
      title: "Home",
      url: "/",
    },
    {
      title: "Who we are",
      url: "/who-we-are",
    },
    {
      title: "Training",
      url: "/training",
    },
    {
      title: "Testimonials",
      url: "/testimonials",
    },
    {
      title: "Get in touch",
      url: "/get-in-touch",
    },
  ];

  return (
    <nav
      className={`ae-nav-container -light-theme ${
        open ? "ae-hamburger-open" : "ae-hamburger-closed"
      }`}
      data-testid="nav-container"
    >
      <Socials theme={"light-theme"} position={"right"} />
      <div
        className="ae-nav-options-container"
        data-testid="nav-options-container"
      >
        {navOptions.map((option, index) => (
          <NavLink
            key={index}
            to={option.url}
            className={({ isActive }) =>
              isActive ? "ae-nav-option -ae-active-page" : "ae-nav-option"
            }
            reloadDocument
          >
            {option.title}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
